import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { installErrorReporter, probeAgentAutofix, resetAgentAutofixProbe } from "../lib/agentautofix-reporter";

const API_BASE = import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api/v1` : "/api/v1";

/**
 * Loads the AgentAutofix click-to-comment widget and error reporter, but only for
 * signed-in users (the identity token route requires the tenant session cookie).
 * Renders nothing.
 */
export default function AgentAutofix() {
  const { tenant } = useAuth();
  const tenantId = tenant?._id;

  useEffect(() => {
    if (!tenantId) return;
    let cancelled = false;
    let uninstall: (() => void) | undefined;
    void probeAgentAutofix().then((ok) => {
      // Unconfigured (503) or unauthenticated: feature disabled for this session.
      if (!ok || cancelled) return;
      uninstall = installErrorReporter();
      if (document.getElementById("zeroexposure-widget-script")) return;
      const s = document.createElement("script");
      s.id = "zeroexposure-widget-script";
      s.src = "/zeroexposure-widget.js";
      s.defer = true;
      s.dataset["tokenUrl"] = `${API_BASE}/agentautofix/token`;
      document.body.appendChild(s);
    });
    return () => {
      // Session cleared or changed (sign-out / different user): tear everything down so the
      // next sign-in re-probes and nothing queued under the old identity is ever sent.
      cancelled = true;
      uninstall?.();
      resetAgentAutofixProbe();
      (window as unknown as { __zeroexposureTeardown?: () => void }).__zeroexposureTeardown?.();
      document.getElementById("zeroexposure-widget-script")?.remove();
    };
  }, [tenantId]);

  return null;
}
